import classNames from 'classnames';
import { DateTime } from 'luxon';
import { ChangeEvent, FC, useMemo, useState } from 'react';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { useCalendarEvents } from '../../../services/calendar/calendar.service';
import { useActiveGlobalFreezes } from '../../../services/freeze/freeze.service';
import useFranchiseeAlias from '../../../utils/useFranchiseeAlias/useFranchiseeAlias';
import Calendar from './Calendar/Calendar';
import styles from './CalendarPage.module.css';
import { useTranslation } from 'react-i18next';

const CalendarPage: FC = () => {
  const { t } = useTranslation();
  const { alias } = useFranchiseeAlias();
  const { data: activeGlobalFreezeData } = useActiveGlobalFreezes(true);
  const freezeExists = activeGlobalFreezeData?.data && activeGlobalFreezeData?.data?.length > 0;
  const [filters, setFilters] = useState({
    NATIONAL_PROGRAM: true,
    HOLIDAY: true,
    MAINTENANCE: true,
    GLOBAL_FREEZE: true,
  });

  const [dates, setDates] = useState({
    startTime: DateTime.now().minus({ months: 2 }).toISODate(),
    endTime: DateTime.now().plus({ months: 2 }).toISODate(),
  });

  const { data } = useCalendarEvents(true, dates);

  const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checkboxId = event.target.id as keyof typeof filters;
    setFilters((prevFilters) => ({ ...prevFilters, [checkboxId]: !prevFilters[checkboxId] }));
  };

  const filteredEvents = useMemo(() => data?.data.filter((event) => filters[event.type]) || [], [data, filters]);

  return (
    <>
      <div className={styles.header}>{t('calendar.title')}</div>
      <div
        className={classNames(styles.calendarPage, {
          [styles.withAlias]: alias !== null,
          [styles.withFreeze]: freezeExists,
        })}
      >
        <div className={styles.filterSection}>
          <h2 className={styles.filterLabel}>{t('calendar.filterLabel')}</h2>
          <div className={styles.filters}>
            <Checkbox
              label={t('calendar.filters.nationalDeals')}
              id="NATIONAL_PROGRAM"
              checked={filters.NATIONAL_PROGRAM}
              onChange={handleFilterChange}
            />
            <Checkbox
              label={t('calendar.filters.holidays')}
              id="HOLIDAY"
              checked={filters.HOLIDAY}
              onChange={handleFilterChange}
            />
            <Checkbox
              label={t('calendar.filters.maintenanceFreezes')}
              id="MAINTENANCE"
              checked={filters.MAINTENANCE}
              onChange={handleFilterChange}
            />
            <Checkbox
              label={t('calendar.filters.toolkitFreezes')}
              id="GLOBAL_FREEZE"
              checked={filters.GLOBAL_FREEZE}
              onChange={handleFilterChange}
            />
          </div>
        </div>
        <Calendar className={styles.calendar} events={filteredEvents} setDates={setDates} />
      </div>
    </>
  );
};

export default CalendarPage;
